import { demoEnergyDeviceList, demoEnergyMode } from "../demo/demoDevices";

// Use registered device identities; none of the dummy measurements or predictions.
export const buildForecastEnergyOverview = (config, prediction = null, measurements = null, range = null, registered = undefined) => {
  const mode = demoEnergyMode(config, registered);
  const forecast = prediction?.forecast ?? [];
  const forecastOrigin = prediction?.forecastOrigin ?? null;
  const comparisonHour = prediction?.comparisonHour ?? null;
  const devices = demoEnergyDeviceList(config, registered).map((device) => {
    const cube = prediction?.deviceForecasts?.find((item) => item.deviceSn === device.serialNum);
    const tipsPole = device.deviceType === "POLE" && device.serialNum === "DEMO-P1" && prediction?.scenario === "TIPS";
    const legacyCube = device.deviceType === "CUBE" && ["DEMO-C1", "DEMO-C2", "DEMO-C3"].includes(device.serialNum)
      && prediction?.scenario === "GOVTECH" && !prediction.deviceForecasts;
    return {
      deviceSn: device.serialNum,
      deviceType: device.deviceType,
      role: device.role,
      name: device.name,
      operatingStatus: device.operatingStatus,
      isConnected: null,
      latest: null,
      history: [],
      daily: [],
      forecast: cube?.forecast ?? (tipsPole || legacyCube ? forecast : []),
      forecastHistory: (tipsPole ? prediction?.forecastHistory : cube?.forecastHistory) ?? [],
      calibration: cube?.calibration ?? null,
      forecastOrigin,
      comparisonHour,
      consumptionPending: true,
    };
  });
  const pole = devices.find((device) => device.deviceType === "POLE");
  if (pole && measurements?.deviceSn === pole.deviceSn && measurements.source === "SIMULATOR") {
    pole.latest = measurements.latest ?? null;
    pole.comparisonHour = comparisonHour ?? measurements.comparisonHour ?? null;
    pole.history = (measurements.history ?? []).map((point) => ({
      ts: point.ts, solarW: point.solarW, windW: point.windW,
      genW: point.solarW + point.windW, consW: point.consumptionW,
    }));
    pole.daily = (measurements.daily ?? []).filter((point) =>
      (!range?.from || point.statDate >= range.from) && (!range?.to || point.statDate <= range.to));
  }
  const sumPoints = (points, field) => {
    const values = points.map((point) => point?.[field]);
    // ALL sums the displayed predictions; an unknown device contributes the same 0 W fallback.
    if (field === "consW" && values.some((value) => value != null)) {
      return values.reduce((sum, value) => sum + (value ?? 0), 0);
    }
    return values.every((value) => value != null) ? values.reduce((sum, value) => sum + value, 0) : null;
  };
  const pastTimes = [...new Set(devices.flatMap((device) => device.forecastHistory.map((point) => new Date(point.ts).getTime())))].sort((a, b) => a - b);

  return {
    energy: {
      mode,
      generationForecast: prediction,
      devices,
      group: mode === "FOG" ? {
        memberCount: devices.length,
        reportingCount: 0,
        totalGenW: null,
        totalConsW: null,
        surplusW: null,
        history: [],
        daily: [],
        // Sum the per-cube predictions after calibration; actuals remain absent.
        forecast: forecast.map((point, index) => ({
          ts: point.ts,
          genW: sumPoints(devices.map((device) => device.forecast[index]), "genW"),
          consW: sumPoints(devices.map((device) => device.forecast[index]), "consW"),
        })),
        forecastHistory: pastTimes.map((time) => {
          const points = devices.map((device) => device.forecastHistory.find((point) => new Date(point.ts).getTime() === time));
          return { ts: new Date(time).toISOString(), genW: sumPoints(points, "genW"), consW: sumPoints(points, "consW") };
        }),
        forecastOrigin,
        comparisonHour,
        consumptionPending: true,
      } : null,
    },
  };
};
